import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ToggleButtonGroup from './ToggleButtonGroup';

export default class ClayCalc extends Component {

	table = [
		{
			label: 'Youth Mound – 6" high',
			sqft: 24,
			bricks: [102, 186],
			bags: [18, 24],
		},
		{
			label: 'Youth Mound – 8" high',
			sqft: 34,
			bricks: [145, 264],
			bags: [26, 34],
		},
		{
			label: 'Adult Mound – 10" high',
			sqft: 50,
			bricks: [212, 388],
			bags: [38, 50],
		},
		{
			label: "Youth Batter's Box",
			sqft: 18,
			bricks: [77, 140],
			bags: [14, 18],
		},
		{
			label: "Adult Batter's Box",
			sqft: 24,
			bricks: [102, 186],
			bags: [18, 24],
		},
		{
			label: "Softball Pitching Area",
			sqft: 26,
			bricks: [109, 199],
			bags: [20, 26],
		},
		{
			label: "Softball Batter's Box",
			sqft: 21,
			bricks: [89, 163],
			bags: [16, 21],
		},
		{
			label: "Catcher's Box – Baseball",
			sqft: 20,
			bricks: [85, 155],
			bags: [15, 20],
		},
		{
			label: "Catcher's Box – Softball",
			sqft: 25,
			bricks: [106, 194],
			bags: [19, 25],
		},
	];

	depthOptions = {
		bricks: ['2 ¼"', '4"'],
		bags: ['3"', '4"'],
	};

	constructor(props) {
		super(props);

		this.state = {
			product: (typeof props.product !== 'undefined') ? props.product : null,
			project: null,
			depth: null,
		};
	}

	handleChange = (event) => {
		const { name, value } = event.target;

		this.setState({
			[name]: value
		});
	}

	render() {
		const labelCols = 'small-4 columns';
		const fieldCols = 'small-8 columns';

		return (
			<>
				<p><b>How much clay do you need?</b> Select your project details below to find out. Reference the <a href="https://ballfields.com/baseball-field-dimensions/" target="_top">Ballfield Dimensions Guide</a> for detailed information about laying out your ballfield.</p>

				<div className="row">
					<div className="medium-4 columns">

						<div className="ClayCalc__field row">
							<div className={"ClayCalc__field-label " + labelCols}>Field Area:</div>
							<div className={fieldCols}>
								<select name="project" onChange={this.handleChange}>
									<option value={null}>Select…</option>
									{this.table.map(({label}, index) => <option value={index}>{label}</option> )}
								</select>
							</div>
						</div>
						{typeof this.props.product !== 'undefined' ?
							<input type="hidden" name="product" value={this.state.product}/>
							:
							<div className="ClayCalc__field row">
								<div className={"ClayCalc__field-label " + labelCols}>Material:</div>
								<div className={fieldCols}>
									<ToggleButtonGroup name="product" vertical="true" options={[
										['Beacon ProBricks', 'bricks'],
										['Bagged Shredded Clay', 'bags'],
									]} changeHandler={this.handleChange} />
								</div>
							</div>
						}
						{this.state.product !== null &&
							<div className="ClayCalc__field row">
								<div className={"ClayCalc__field-label " + labelCols}>Clay Depth:</div>
								<div className={fieldCols}>
									<ToggleButtonGroup name="depth" options={this.depthOptions[this.state.product].map((label, index) => [label, index])} changeHandler={this.handleChange} />
								</div>
							</div>
						}
					</div>
					<div className="medium-8 columns">
						{((this.state.product !== null) && (this.state.project !== null) && (this.state.depth !== null)) &&
							<table className="ClayCalc__info">
								<thead>
									<tr>
										<th>Sq. Ft.</th>
										<th>{this.state.product.charAt(0).toUpperCase() + this.state.product.substr(1).toLowerCase()}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{this.table[this.state.project].sqft}</td>
										<td>{this.table[this.state.project][this.state.product][this.state.depth]}</td>
									</tr>
								</tbody>
							</table>
						}
					</div>
				</div>
			</>
		);
	} // render()

} // component

document.querySelectorAll('.ClayCalc').forEach(el => {
	ReactDOM.render(<ClayCalc {...el.dataset} />, el);
});
